import { buildActivityPedagogicalCard } from '../lib/activity-pedagogy.js';

function TextList({ items, empty = 'Não informado.' }) {
  if (!items?.length) return <p className='hint'>{empty}</p>;
  return <ul>{items.map((item, index) => <li key={`${item}-${index}`}>{item}</li>)}</ul>;
}

export function ActivityPedagogicalCard({ activity, compact = false }) {
  const card = buildActivityPedagogicalCard(activity);
  const visibleSteps = compact ? card.steps.slice(0, 3) : card.steps;
  const hiddenStepCount = Math.max(0, card.steps.length - visibleSteps.length);

  return <div className={`pedagogical-card${compact ? ' pedagogical-card--compact' : ''}`}>
    <div className='pedagogical-card__quick'>
      <section><h4>Objetivo</h4><p>{card.objective}</p></section>
      <section><h4>Quando indicar</h4><p>{card.whenToUse}</p></section>
      <section>
        <h4>Roteiro</h4>
        <TextList items={visibleSteps} empty='Roteiro ainda não informado.' />
        {hiddenStepCount > 0 && <p className='hint'>Mais {hiddenStepCount} etapa(s) no roteiro completo.</p>}
      </section>
      <section><h4>Como registrar</h4><p>{card.howToRecord}</p></section>
      <section><h4>Adaptação principal</h4><p>{card.mainAdaptation}</p></section>
    </div>

    <details className='pedagogical-card__details'>
      <summary>Ver fundamentação e detalhes</summary>
      <div className='pedagogical-card__details-grid'>
        <section><h4>Materiais</h4><TextList items={card.materials} /></section>
        <section><h4>Por que funciona</h4><p>{card.whyWorks}</p></section>
        <section><h4>Pré-requisitos</h4><TextList items={card.prerequisites} empty='Nenhum pré-requisito rígido informado; ajuste pela observação direta.' /></section>
        <section><h4>Simplificar</h4><p>{card.simplify}</p><h4>Progredir</h4><p>{card.progress}</p></section>
        <section><h4>Sinais de inadequação</h4><TextList items={card.inadequacySigns} /></section>
        <section><h4>Erros comuns</h4><TextList items={card.commonErrors} /></section>
        <section><h4>Generalização</h4><p>{card.generalization}</p><h4>Critério de domínio</h4><p>{card.criterion}</p></section>
        <section className='pedagogical-card__provenance'>
          <h4>Autoria e curadoria</h4><p>{card.authorship}</p>
          <h4>Fonte de referência</h4><p>{card.source}</p>
          <h4>Situação de validação</h4><p>{card.validation}</p>
          <p className='hint'>Referência bibliográfica, autoria e validação são informações diferentes. Uma fonte geral não comprova que esta atividade foi retirada ou validada por ela.</p>
        </section>
      </div>
    </details>
  </div>;
}
